module.exports = __webpack_public_path__ + "img/appBrand--ax-full-dark.8a0853fe.svg";